import { TIconProps } from './utils';

export const ArrowMenuIcon = ({ className = '' }: TIconProps) => (
  <svg
    width='25'
    height='25'
    viewBox='0 0 25 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <g id='mdi_keyboard_arrow_down' clipPath='url(#clip0_2098_61136)'>
      <path
        id='Vector'
        d='M8.6338 18.7526C8.22929 18.36 8.22894 17.7109 8.63302 17.318L12.8507 13.2164C13.2545 12.8237 13.2545 12.1752 12.8507 11.7826L8.63302 7.68099C8.22894 7.28803 8.22929 6.63894 8.6338 6.24642L8.95124 5.93839C9.33919 5.56194 9.95607 5.56194 10.344 5.93839L16.366 11.7818C16.7708 12.1746 16.7708 12.8243 16.366 13.2171L10.344 19.0606C9.95607 19.437 9.33919 19.437 8.95124 19.0606L8.6338 18.7526Z'
        fill='inherit'
      />
    </g>
    <defs>
      <clipPath id='clip0_2098_61136'>
        <rect width='25' height='25' fill='inherit' transform='matrix(0 -1 1 0 0 25)' />
      </clipPath>
    </defs>
  </svg>
);
